function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCloudRexFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M27.791 17.352c.132-.439.202-.894.209-1.352a5 5 0 00-5-5 4.95 4.95 0 00-1.495.253A7.995 7.995 0 006 14c0 .225.016.446.034.667A6.996 6.996 0 009 28h15a5.998 5.998 0 003.791-10.648z",
    fill: props.color
  }));
}

export default SvgIconCloudRexFilled;